// IMPORT (HARDEN): the stored row of a guided import (`cell.import_run`), checked against its
// table (contract-bindings). The API serves its projection `ImportRun` (api/import-runs.ts):
// typed preview, mapping and report, the progress grouped, and no object store key.
import { z } from "zod";
import { ActorShortColumns } from "./actor";
import { ImportRunSource, ImportRunStatus } from "./enums";
import { Timestamp, Uuid } from "./primitives";

export const ImportRunRow = z
  .object({
    company_id: Uuid,
    id: Uuid,
    source: ImportRunSource,
    status: ImportRunStatus,
    file_name: z.string(),
    file_bytes: z.int().min(0),
    object_key: z.string(),
    preview: z.record(z.string(), z.unknown()),
    mapping: z.record(z.string(), z.unknown()),
    phase: z.string().nullable(),
    done: z.int().min(0),
    total: z.int().min(0),
    report: z.record(z.string(), z.unknown()).nullable(),
    error: z.string().nullable(),
    cancel_requested_at: Timestamp.nullable(),
    queued_at: Timestamp.nullable(),
    started_at: Timestamp.nullable(),
    finished_at: Timestamp.nullable(),
    created_by_membership_id: Uuid.nullable(),
    ...ActorShortColumns.shape,
    created_at: Timestamp,
    updated_at: Timestamp,
  })
  .meta({ id: "ImportRunRow" });
export type ImportRunRow = z.infer<typeof ImportRunRow>;
